import React from 'react';
import MessageCarousel from "./MessageCarousel";

class Messaging extends React.Component {
    render() {
        return (
            <section className="wrap-top" id="messaging">
                <div className="content">
                    <h2 className="title" id="messageHeader"><span>From Us</span></h2>
                    <ul className="messaging-list">
                        <MessageCarousel
                            messageList={this.props.messageList}
                            onClick={(i) => this.props.onClick(i)}
                            PCBID={this.props.PCBID}
                        />
                    </ul>
                </div>
            </section>
        );
    }
}

export default Messaging;